import Button from "../../component/button/Button";
import { getLibraryByCategory } from "../../api/HttpApis";
import { trimStr } from "../../utils/theme/ShortenedText/ShortenedText";
import { useSearch } from "../../context/SearchContext";
import { useState } from "react";
import { CiImageOn } from "react-icons/ci";
import { buildContentCard } from "../../component/ListView/contentCard";

const MediaImage = ({ src, alt }) => {
  const [hasError, setHasError] = useState(false);
  if (hasError || !src) return <CiImageOn size={40} />;
  return (
    <img
      className="imageBox"
      src={src}
      alt={alt || "Media"}
      width={40}
      height={30}
      onError={() => setHasError(true)}
    />
  );
};

const useMovieData = () => {
  const { searchQuery } = useSearch();
  const movieListData = async (
    selectedDate,
    selectedCreator,
    selectedRating,
    selectedGenre,
    page,
    perpage
  ) => {
    const response = await getLibraryByCategory(
      "Movie",
      {},
      selectedDate,
      selectedCreator,
      selectedRating,
      selectedGenre,
      perpage,
      page,
      searchQuery ? searchQuery : ""
    );
    const data = Array.isArray(response?.data?.data) ? response.data.data : [];

    return data?.map((item) => ({
      id: item.id || item.original_id || item.video_id || item.movie_id,
      metadata_id: item.metadata_id || item.meta_id || item.meta_data_id,
      name: trimStr(item.name),
      media: item.portrait,
      status: item.status,
      qc_status: item.qc_status,
      qc_reason: item.qc_reason,
      qc_note: item.qc_note,
      rating: item.rating || "N/A",
      access: item.access,
      buttonText: "Edit",
      buttonText2: "Delete",
      totalCount: response?.data?.total,
    }));
  };

  const getColumns = (handleEdit, handleDelete, deletingId) => [
    {
      key: "name",
      label: "Name",
      render: (item) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
            display: "block",
            minWidth: 0,
          }}
        >
          {trimStr(item.name, 15)}
        </div>
      ),
    },
    {
      key: "media",
      label: "Media",
      render: (item) => <MediaImage src={item.media} alt={item.name} />,
    },
    { key: "status", label: "Status" },
    { key: "rating", label: "Rating" },
    { key: "access", label: "Access" },
    {
      key: "buttonText",
      render: (item) => (
        <Button onClick={() => handleEdit(item.id, item.metadata_id)}>
          {item.buttonText}
        </Button>
      ),
    },
    {
      key: "buttonText2",
      render: (item) => (
        <Button
          onClick={() => handleDelete(item.id, item.metadata_id)}
          loading={deletingId === (item.metadata_id || item.id)}
          disabled={deletingId === (item.metadata_id || item.id)}
        >
          {item.buttonText2}
        </Button>
      ),
    },
  ];

  return { movieListData, getColumns, getCard: buildContentCard };
};

export default useMovieData;